var app = angular.module('leonardo');

var WidgetContactTypes = function(PermissionService, FilterService, ContactTypeRestService) {
  return {
    restrict: 'A',
    require: ['ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      filter:'@',
      accountUser: '='
    },
    templateUrl: 'views/templates/widget/contact-types.html',
    link: function (scope, element, attrs, ctrls) {
      scope.ngModelCtrl = ctrls[0];
      scope.formCtrl = scope.$parent.Form ? scope.$parent.Form : { '$submitted' : true };
      scope.permissionService = PermissionService;
      scope.contactTypeRestService = ContactTypeRestService;
      scope.init = false;

      scope.types = ContactTypeRestService.getAll({essential: true}, false, true);

      scope.ngModelCtrl.$render = function () {
        scope.contact_types = scope.ngModelCtrl.$viewValue;
        if (isNull(scope.contact_types) && scope.filter) {
          scope.contact_types = FilterService.getFilter(scope.filter);
        }
        if (!isNull(scope.contact_types)) {
          scope.contact_types = (angular.isArray(scope.contact_types) ? scope.contact_types : scope.contact_types.split(','));
        }
        else {
          scope.contact_types = [];
        }
        var defaultValues = [];
        angular.forEach(scope.contact_types, function (dynamic) {
          defaultValues.push(dynamic && dynamic.id ? dynamic.id : dynamic);
        });
        scope.contact_types = defaultValues;
      };

      scope.updateModel = function() {
        var contact_types = [];
        angular.forEach(scope.contact_types, function (contact_type) {
          if (!isEmpty(contact_type)) {
            contact_types.push(contact_type);
          }
        });
        scope.ngModelCtrl.$setViewValue(contact_types);
        if (scope.filter) {
          FilterService.setFilter(scope.filter, contact_types);
        }
      };


      scope.$watch('contact_types', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue) || !scope.init) {
          scope.updateModel();
        }
      });

      scope.removeContactType = function(index) {
        var contact_types = angular.copy(scope.contact_types);
        angular.forEach(scope.contact_types, function(value, key){
          if (key > index) {
            contact_types[key-1] = contact_types[key];
          }
        });
        contact_types.splice(contact_types.length-1, 1);
        scope.contact_types = contact_types;
      };

      scope.ngModelCtrl.$validators.required = function(modelValue) {
        if (!scope.required) {
          return true;
        }
        var empty = true;
        angular.forEach(modelValue, function (contac_type) {
          if (!isEmpty(contac_type)){
            empty = false;
          }
        });
        return !empty;
      };

    }
  };
};

app.directive('widgetContactTypes', ['PermissionService', 'FilterService', 'ContactTypeRestService', WidgetContactTypes]);
